import {css} from '@emotion/css';
import {useMemo} from 'react';

import {useWolfTheme} from '../../contexts';

const useStyles = () => {
    const theme = useWolfTheme();

    return useMemo(
        () => ({
            wrapper: css({
                display: 'flex',
                width: '100%',
                flexWrap: 'wrap',
                justifyContent: 'space-between',
                gap: theme.orbitalThree,
            }),
            primaryActions: css({
                marginLeft: 'auto',
            }),
        }),
        [theme.orbitalThree]
    );
};

export default useStyles;
